import { theme } from '@global-engineering-shared/gweb-global-theme';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  details: {
    height: '24px',
    fontSize: '14px',
    display: 'flex',
  },
  separator: {
    backgroundColor: theme.palette.common.black,
    width: theme.spacing(0.5),
    height: theme.spacing(0.5),
    alignSelf: 'center',
    borderRadius: theme.spacing(1.25),
    margin: theme.spacing(0.5),
  },
});

export default useStyles;
